import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { useTranslation } from "react-i18next";

const PersonDetailContracts = () => {
  const {t} = useTranslation()
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={t("Email")} fieldName={"email"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={t("ActualAddress")} fieldName={"actualAddress"} />
        </Col>
      </Row>
    </>
  );
};

export default PersonDetailContracts;
